import React, { Component } from 'react';
import { Section } from 'bulma-react'
// import { Link } from 'react-router-dom';
import BlogSummary from './BlogSummary';
import { AddButton } from './common';
import { store } from '../services';

import db from '../data/tmp';
const data = {
  user: db.users.data[0],
}

class Blogs extends Component {
  constructor(props) {
    super(props);
    this.state = { blogs: {} };
  }
  getBlogs = () => {
    const { showUpdates } = this.props;
    store.main.find({}, { remoteOnly: !showUpdates })
    // store.main.find()
    .then(list => {
      this.setState({ blogList: list, blogTotal: list.total });
      const topId = list[0]._id;
      this.loadMore(topId);
    })
    .catch(err => console.error(err));
  };
  loadMore = (id) => {
    if (!id) {
      return;
    }
    store.main.findOne(id)
    .then(item => this.setState({ blogs: {
      ...this.state.blogs, [id]: item
    } }))
    .catch(err => console.error(err));
  };
  onEdit = (id) => {
    if (!id) {
      return;
    }
    const { history } = this.props;
    history.push(`/edit/${id}`);
  };
  onAddNew = () => {
    const { history } = this.props;
    history.push('/edit');
  };
  componentDidMount = () => {
    this.getBlogs();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.showUpdates !== this.props.showUpdates) {
      this.getBlogs();
    }
  };
  dumpUpdated = () => {
    return store.main.dumpUpdated();
  };
  render() {
    const { user } = data;
    const { blogList } = this.state;
    const { showUpdates } = this.props;
    return (
      <Section blogs style={{
        paddingTop: '0.75rem',
      }}>
        { blogList &&
          blogList.map((blog, idx) => {
            const _blog = this.state.blogs[blog._id] || blog;
            const opened = idx === 0;
            return (
              <BlogSummary key={ `summary-${ idx }` } blog={ _blog } user={ user }
              loadMore={ this.loadMore } onEdit={this.onEdit}opened={opened}/>
            );
          })
        }
        <AddButton onClick={this.onAddNew}/>
      </Section>
    );
  }
}

export default Blogs;




// WEBPACK FOOTER //
// ./src/components/Blogs.js